// import { Button, Grid, Paper, Typography } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import {
//   Control,
//   FieldErrors,
//   UseFormRegister,
//   UseFormReset,
// } from "react-hook-form";
// import WSSelectField from "../../Components/Select/WSSelect";
// import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
// import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
// import {
//   callAPI,
//   IRoleMain,
//   IsSmallScreen,
//   MasterPages,
//   Method,
// } from "../../commonFunctions/CommonFunctions";
// import PermissionDenied from "../../commonFunctions/PermissionDenied";
// import { getPermissions } from "../../commonFunctions/PermissionManger";
// import WSRadioField from "../../Components/Radio/WSRadio";
// import { WSIcons } from "../../commonFunctions/iIcons";
// import WSDateField from "../../Components/DateField/WSDateField";
// import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
// import config from "../../Config/clientConfig.json"
// interface PaymentOutProps {
//   control: Control<any>;
//   errors: FieldErrors;
//   register: UseFormRegister<any>;
//   id: any;
//   reset: UseFormReset<any>;
//   departmentId?: string;
//   setValue: any;
// }
// const PaymentOut: React.FC<PaymentOutProps> = ({
//   control,
//   errors,
//   register,
//   id,
//   reset,
//   departmentId,
//   setValue,
// }) => {
//   const isMobile = IsSmallScreen();
//   useEffect(
//     () => () => {
//       reset();
//     },
//     [id, reset],
//   );

//   const [showExtraFields, setShowExtraFields] = useState(false);
//   const genId = () =>
//     Date.now().toString(36) + Math.random().toString(36).slice(2);
//   const [paymentRows, setPaymentRows] = useState(() => [
//     { id: genId(), paymentType: "", amount: "" },
//   ]);

//   const handleAddRow = () =>
//     setPaymentRows((prev) => [
//       ...prev,
//       { id: genId(), paymentType: "", amount: "" },
//     ]);
//   const handleRemoveRow = (idToRemove: any) =>
//     setPaymentRows((prev) => prev.filter((r) => r.id !== idToRemove));

//   return (
//     <>
//       <Grid
//         style={{
//           paddingLeft: 5,
//           paddingRight: 20,
//           position: "relative",
//           margin: 0,
//           marginTop: "3rem",
//         }}
//         container
//         spacing={2}
//       >
//         <Grid item xs={12} sm={6}>
//           <WSSelectField
//             rules={{ required: true }}
//             {...register("party")}
//             id="party"
//             control={control}
//             isMobile={isMobile}
//             label="Party"
//             name="party"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <WSTextField
//             label={"Bill No"}
//             {...register("billNo")}
//             id="billNo"
//             name="billNo"
//             control={control}
//             rules={{ required: false }}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           {!showExtraFields ? (
//             <>
//               <WSSelectField
//                 label="Payment Type"
//                 rules={{ required: true }}
//                 {...register("paymentType")}
//                 id={"paymentType"}
//                 control={control}
//                 options={config.paymentType.staticOptionData}
//               />
//               <Button
//                 variant="text"
//                 size="small"
//                 sx={{ textTransform: "none", p: 0, mt: 1 }}
//                 onClick={() => setShowExtraFields(true)}
//               >
//                 + Add Payment Details
//               </Button>
//             </>
//           ) : (
//             <Paper sx={{ p: 2 }}>
//               <Grid container spacing={2}>
//                 {paymentRows.map((row, index) => (
//                   <React.Fragment key={row.id}>
//                     <Grid item xs={12} sm={4}>
//                       <WSSelectField
//                         label="Payment Type"
//                         {...register(`paymentRows.${index}.paymentType`)}
//                         id={`paymentType-${row.id}`}
//                         control={control}
//                         options={config.paymentType.staticOptionData}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={4}>
//                       <WSTextField
//                         label="Amount"
//                         {...register(`paymentRows.${index}.amount`)}
//                         id={`amount-${row.id}`}
//                         control={control}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={4}>
//                       <WSIcons.DeleteIcon
//                         onClick={() => handleRemoveRow(row.id)}
//                         sx={{ cursor: "pointer" }}
//                       />
//                     </Grid>
//                   </React.Fragment>
//                 ))}

//                 <Grid item xs={12}>
//                   <Button
//                     variant="text"
//                     size="small"
//                     sx={{ textTransform: "none", p: 0, mt: 1 }}
//                     onClick={handleAddRow}
//                   >
//                     + Add Payment Type
//                   </Button>
//                 </Grid>
//               </Grid>
//             </Paper>
//           )}
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <WSDateField
//             id="billDate"
//             name="billDate"
//             label={"Bill Date "}
//             dateFormat="DD-MM-YYYY"
//             denyFuturOrPast="custom"
//             control={control}
//             rules={{ required: false }}
//           />
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <WSTextField
//             label={"Paid"}
//             {...register("paid")}
//             id="paid"
//             name="paid"
//             control={control}
//             rules={{ required: false }}
//           />
//         </Grid>
//         <Grid item xs={12}>
//           <WSTextAreaField
//             label={"Description"}
//             id={"description"}
//             name={"description"}
//             control={control}
//             rules={{ required: false }}
//             rows={3}
//           />
//         </Grid>
//         <Grid item xs={12}>
//           <WSImageUpload
//             control={control}
//             id="image"
//             name="image"
//             label=""
//             rules={{ required: false }}
//           />
//         </Grid>
//       </Grid>
//     </>
//   );
// };
// export default PaymentOut;





import { Button, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
} from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import {
  callAPI,
  IRoleMain,
  IsSmallScreen,
  MasterPages,
  Method,
  dateFormat,
} from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import WSRadioField from "../../Components/Radio/WSRadio";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import config from "../../Config/clientConfig.json";
import WSAutocompleteField from "../../Components/AutoComplete/AutoComplete";

interface PaymentOutProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id?: string;
  reset: UseFormReset<any>;
  departmentId?: string;
  setValue: UseFormSetValue<any>;
  rowData?: any;
  partyOptions?: any[];
}

const PaymentOut: React.FC<PaymentOutProps> = ({
  control,
  errors,
  register,
  id,
  reset,
  departmentId,
  setValue,
  rowData,
  partyOptions = [], 
}) => {
  const isMobile = IsSmallScreen();
  const imageRef = useRef<HTMLInputElement>(null);
  const isEditMode = Boolean(id);

  const [showExtraFields, setShowExtraFields] = useState(false);
  const genId = () => Date.now().toString(36) + Math.random().toString(36).slice(2);
  const [paymentRows, setPaymentRows] = useState(() => [
    { id: genId(), paymentType: "", amount: "" },
  ]);

  // Load data for edit mode
  useEffect(() => {
    if (isEditMode && rowData) {
      setValue("party", rowData.partyId || "");
      setValue("billNo", rowData.billNo || "");
      setValue("billDate", rowData.billDate ? dateFormat(new Date(rowData.billDate), "DD-MM-YYYY") : "");
      setValue("paid", rowData.paid?.toString() || "");
      setValue("description", rowData.description || "");
      
     const payments = rowData.paymentOutLine || [];
    if (payments.length > 0) {
      // Set form field values
      payments.forEach((payment: any, index: number) => {
        setValue(`paymentRows.${index}.paymentType`, payment.paymentType || "");
        setValue(`paymentRows.${index}.amount`, payment.amount?.toString() || "");
      });
      
      // Update local state for UI
      setPaymentRows(payments.map((payment: any) => ({
        id: genId(),
        paymentType: payment.paymentType || "",
        amount: payment.amount?.toString() || ""
      })));
      
      setShowExtraFields(true);
    } else {
      // Reset to default if no payments
      setPaymentRows([{ id: genId(), paymentType: "", amount: "" }]);
      setShowExtraFields(false);
    }
    
    console.log("✅ Payment data loaded - paymentRows set:", payments);
  }
}, [rowData, setValue, isEditMode]);

  // Reset form when ID changes
  useEffect(
    () => () => {
      reset();
    },
    [id, reset],
  );

  const handleAddRow = () =>
    setPaymentRows((prev) => [
      ...prev,
      { id: genId(), paymentType: "", amount: "" },
    ]);
    
  const handleRemoveRow = (idToRemove: any) =>
    setPaymentRows((prev) => prev.filter((r) => r.id !== idToRemove));

  return (
    <>
      <Grid
        style={{
          paddingLeft: 5,
          paddingRight: 20,
          position: "relative",
          margin: 0,
          marginTop: "3rem",
        }}
        container
        spacing={2}
      >
        <Grid item xs={12} sm={6}>
  <WSAutocompleteField
    rules={{ required: true }}
    id="party"
    control={control}
    label="Vendor"
    name="party"
    options={partyOptions || []}
    isMobile={isMobile}
  />
</Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            label={"Bill No"}
            {...register("billNo")}
            id="billNo"
            name="billNo"
            control={control}
            rules={{ required: false }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          {!showExtraFields ? (
            <>
              <WSSelectField
                label="Payment Type"
                rules={{ required: true }}
                {...register("paymentType")}
                id={"paymentType"}
                control={control}
                options={config.paymentType.staticOptionData}
              />
              <Button
                variant="text"
                size="small"
                sx={{ textTransform: "none", p: 0, mt: 1 }}
                onClick={() => setShowExtraFields(true)}
              >
                + Add Payment Details
              </Button>
            </>
          ) : (
            <Paper sx={{ p: 2 }}>
              <Grid container spacing={2}>
                {paymentRows.map((row, index) => (
                  <React.Fragment key={row.id}>
                    <Grid item xs={12} sm={4}>
                      <WSSelectField
                        label="Payment Type"
                        {...register(`paymentRows.${index}.paymentType`)}
                        id={`paymentType-${row.id}`}
                        control={control}
                        options={config.paymentType.staticOptionData}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <WSTextField
                        label="Amount"
                        {...register(`paymentRows.${index}.amount`)}
                        id={`amount-${row.id}`}
                        control={control}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <WSIcons.DeleteIcon
                        onClick={() => handleRemoveRow(row.id)}
                        sx={{ cursor: "pointer" }}
                      />
                    </Grid>
                  </React.Fragment>
                ))}

                <Grid item xs={12}>
                  <Button
                    variant="text"
                    size="small"
                    sx={{ textTransform: "none", p: 0, mt: 1 }}
                    onClick={handleAddRow}
                  >
                    + Add Payment Type
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <WSDateField
            id="billDate"
            name="billDate"
            label={"Bill Date "}
            dateFormat="DD-MM-YYYY"
            denyFuturOrPast="custom"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            label={"Paid"}
            {...register("paid")}
            id="paid"
            name="paid"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12}>
          <WSTextAreaField
            label={"Description"}
            id={"description"}
            name={"description"}
            control={control}
            rules={{ required: false }}
            rows={3}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <WSImageUpload
            control={control}
            id="image"
            name="image"
            label=""
            rules={{ required: false }}
          />
        </Grid> */}
      </Grid>
    </>
  );
};

export default PaymentOut;
